import React from 'react';
import BaseSection from 'commonComponents/sections/BaseSection/BaseSection';
import styles from './FullWidthBlocks.module.scss';

const FullWidthBlocks = ({ boxes, anchor, lastBox, boxRender }) => {
  return (
    <BaseSection anchor={ anchor }>
      <div className={ styles.FullWidthBlocks }>
        { boxes && boxes.map(boxRender) }
        { lastBox && <div className={ styles.lastBox }>{ lastBox }</div> }
      </div>
    </BaseSection>
  );
};
 
export default FullWidthBlocks;
